import Instagram from "@/icons/Instagram";
import Facebook from "@/icons/Facebook";
import {getImage} from "@public/ulits";
import { FileMarkdownOutlined, HomeOutlined, MailOutlined, MenuOutlined, PhoneOutlined } from "@ant-design/icons";
import { t } from "@/locales";

export default function Footer() {
    return (
      <div className={`w-full bg-img bg-cover`} style={{'--bg': `url(${getImage('flooter.png')})`}}>
          <div className={`footer lg:w-[70%] lg:px-0 px-5 lg:py-[66px] py-6 pb-10  mx-auto  text-xl text-white `}>
              <div className="flex items-center justify-between w-[320px]">
                  <h1 className={`lg:text-[40px] text-2xl font-bold`}>{t('footer.contactUs')}</h1>
                  <div className="flex gap-4">
                    <a href="https://www.facebook.com/profile.php?id=61579363493419" target="_blank" rel="noopener noreferrer">
                        <Facebook size={28} color="rgba(255,255,255,0.8)" />
                    </a>
                      <a href="https://www.instagram.com/u_home_agency/?fbclid=IwY2xjawR5ayRleHRuA2FlbQIxMQBicmlkETFXTldkZW43bHFQdTNreWpFc3J0YwZhcHBfaWQBMAABHuRvtf807PhZ461vvAuR53I8Qjct3PUxWT6LSYL26AqPd0QZOeMYmZbmumqk_aem_t3iUFq2g0ybx0xAlYT-PXQ" target="_blank" rel="noopener noreferrer">
                          <Instagram size={28} color="rgba(255,255,255,0.8)" />
                      </a>
                  </div>
              </div>
              <div className={`lg:flex pt-1 lg:pt-6`}>
                  <h1 className={`lg:w-[250px] lg:text-3xl text-xl tracking-widest hidden`}>Harry Lee</h1>
                  <div className={`text-[rgba(255,255,255,0.8)]`}>
                      <p className={`lg:text-xl pt-2 lg:pt-0 text-base mx-auto text-justify line-height-[32px] tracking-wide `}>
                          <MailOutlined/>&nbsp;&nbsp;<a href="mailto:Harry.Lee@uhomeagency.com" className="hover:text-gold transition-colors">Harry.Lee@uhomeagency.com</a>
                      </p>
                      <p className={`lg:text-xl text-base lg:pt-4 pt-2  mx-auto text-justify line-height-[32px] tracking-wide`}>
                          <PhoneOutlined/>&nbsp;&nbsp;<a href="tel:725-222-0198" className="hover:text-gold transition-colors">725-222-0198</a></p>
                      <p className={`lg:text-xl text-base lg:pt-4 pt-2 mx-auto text-justify line-height-[32px] tracking-wide`}>
                          <HomeOutlined/>&nbsp;&nbsp;5405 W Flamingo Rd</p>
                      <p className={`lg:text-xl text-base lg:pt-4  pt-2 mx-auto text-justify line-height-[32px] tracking-wide`}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Las
                          Vegas, NV 89103</p>
                  </div>
              </div>
          </div>
      </div>
    );
}
